import { render } from "./MainProductsWithMinimumStock.vue?vue&type=template&id=74a8eadc&scoped=true"
import script from "./MainProductsWithMinimumStock.vue?vue&type=script&lang=js"
export * from "./MainProductsWithMinimumStock.vue?vue&type=script&lang=js"

import "./MainProductsWithMinimumStock.vue?vue&type=style&index=0&id=74a8eadc&scoped=true&lang=css"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74a8eadc"]])

export default __exports__